<template>
  <HKLModal
    ref="modal"
    :hasCancelBtn="false"
    :closable="true"
    :title="$t(`termsAndConditions.${regionName}.workPermit.hintForDisableSubApplyBtn`)"
  />
</template>
<script>
import { ref, unref } from '@vue/composition-api'
import HKLModal from '../../../controls/Modal/HKLModal'
import { useStoreGetters } from '@/store'

export default {
  name: 'SubApplyModal',
  components: {
    HKLModal,
  },
  setup () {
    const modal = ref(null)
    const { regionName } = useStoreGetters('regions', 'regionName')
    const open = () => unref(modal).open()
    const close = () => unref(modal).close()
    return {
      modal,
      open,
      close,
      regionName,
    }
  },
}
</script>
<style scoped>
.content {
  color: #0C3A58;
  font-weight: bold;
}
</style>
